import { PublicClientApplication } from "@azure/msal-browser";
import dayjs from 'dayjs';
import { login } from "./azuread";

export default class RosterApi {
    private static readonly BASE_URL: string = process.env.REACT_APP_ROSTER_API_URL!;

    constructor(private readonly msal: PublicClientApplication) { }

    public getRoster(start: Date, end: Date) {
        const startStr = dayjs(start).format('YYYY-MM-DD'), endStr = dayjs(end).format('YYYY-MM-DD');
        return this.msal.acquireTokenSilent({ scopes:[ ...login.scopes ], account: this.msal.getAllAccounts()[0] })
            .then(token => fetch(RosterApi.BASE_URL + `/api/rosters?start=${startStr}&end=${endStr}`, {
                headers: new Headers({
                    'Authorization': 'Bearer ' + token.accessToken
                })
            }).then(response => response.json()));
    }
}